<template>
  <div
    class="bg-login tw-h-auto tw-min-h-screen tw-flex-col tw-flex tw-justify-between tw-w-screen tw-absolute tw-top-0 tw-left-0 back-image-login custom-font"
  >
    <header class=" tw-flex tw-justify-center sm:tw-justify-start">
      <img
        src="../assets/images-v2/logo_logikoss_color2.png"
        class=" tw-w-56 tw-mt-2 sm:tw-mt-11 sm:tw-ml-14 "
      />
    </header>
    <div class="tw-justify-center tw-flex-col tw-self-center">
      <div
        class=" tw-m-5 sm:tw-m-10 tw-text-h1 tw-text-white tw-flex tw-font-semibold tw-justify-center !tw-uppercase"
      >
        <icon-airplane
          class="!tw-fill-primary tw-h-8 tw-w-8 tw-my-auto tw-mr-2"
        />
        {{ $t('fields.login.title') }}
      </div>
      <lgk-modal>
        <div
          class="tw-text-2xl tw-text-black tw-text-center tw-mb-2 tw-font-semibold"
        >
          {{ $t('titles.login') }}
        </div>
        <div
          class="tw-text-sm tw-text-black tw-text-center sm:tw-mb-6 tw-font-semibold"
        >
          {{ $t('messages.login_header') }}
        </div>
        <lgk-textfield
          label="Email"
          v-model="email"
          class="tw-mb-3 sm:tw-mb-6"
          required
        />
        <lgk-textfield
          label="password"
          v-model="password"
          password
          required
          class="tw-mb-3 sm:tw-mb-6"
        />
        <lgk-checkbox
          v-model="checkbox"
          :label="$t('fields.login.rememberme')"
          class="tw-mb-6"
        />
        <div class=" tw-text-red tw-font-semibold tw-text-center">
          {{ authError }}
        </div>
        <lgk-button
          class="tw-mb-3 sm:tw-mb-6"
          full
          text="Login"
          @click="login"
          :loading="loading"
          :disabled="email === '' || password === ''"
        />
        <router-link
          tag="a"
          to="/forgot"
          class=" tw-flex tw-justify-center tw-no-underline !tw-text-alternative-yellow tw-font-semibold tw-text-sm hover:tw-text-alternative-yellow"
          >{{ $t('fields.login.forgot') }}</router-link
        >
        <div class="tw-font-semibold tw-text-sm tw-text-center mt-2 sm:mt-4">
          <p >
            {{ $t('fields.login.dont_account') }}
            <router-link
              :to="{ name: 'Register' }"
              class=" !tw-text-alternative-yellow tw-no-underline  hover:tw-text-alternative-yellow"
              >{{ $t('fields.login.register') }}</router-link
            >
          </p>
        </div>
      </lgk-modal>
      <a
        href="https://logikoss.com/"
        class="tw-m-5 sm:tw-m-10 tw-text-buttons tw-no-underline !tw-text-white tw-flex tw-font-semibold tw-justify-center hover:tw-text-white"
      >
        <icon-back
          class=" tw-fill-black-200 tw-w-6 tw-h-6 tw-my-auto tw-mr-2"
        />{{ $t('fields.login.return') }}</a
      >
    </div>
    <footer
      class=" tw-w-full tw-px-8 tw-py-6 tw-bg-black-500 tw-text-white tw-text-center"
    >
      2023 © Logikoss .Todos los derechos reservados.
    </footer>
  </div>
</template>

<script>
import _ from 'lodash'
import FormErrors from '@/mixins/FormErrors'
import { localize } from 'vee-validate'
import LgkButton from '../components/lgkComponents/LgkButton.vue'
import LgkTextfield from '../components/lgkComponents/LgkTextfield.vue'
import LgkCheckbox from '../components/lgkComponents/LgkCheckbox.vue'
import IconAirplane from '../components/lgkComponents/icons/IconAirplane.vue'
import IconBack from '../components/lgkComponents/icons/IconBack.vue'
import LgkModal from '../components/lgkComponents/LgkModal.vue'

export default {
  name: 'Login',
  mixins: [FormErrors],
  components: {
    LgkButton,
    LgkTextfield,
    LgkCheckbox,
    IconAirplane,
    LgkModal,
    IconBack
  },
  data () {
    return {
      email: '',
      password: '',
      authError: '',
      loading: false,
      checkbox: false,
      back_image: '',
      show: false
    }
  },
  mounted () {
    this.back_image = document.getElementById('app')
    this.back_image.classList.add('back-image-login')
    localize(localStorage.getItem('locale') || 'en')
  },
  destroyed () {
    this.back_image.classList.remove('back-image-login')
  },
  computed: {
    hasChangePassword () {
      return this.$route.params.change_password || false
    },
    hasExpiredPassword () {
      return this.$route.params.password_expired || false
    },
    eyeIcon () {
      return !this.show ? 'fa-eye' : 'fa-eye-slash'
    },
    imageFlag () {
      const language = localStorage.getItem('locale')
      if (language === 'es') {
        return require('../../src/assets/images-v2/flags/spain.jpg')
      }
      return require('../../src/assets/images-v2/flags/us.jpg')
    },
    language () {
      const language = localStorage.getItem('locale') || 'es'
      return language.toUpperCase()
    },
    userLogged () {
      return this.$store.getters.userLogged
    }
  },
  methods: {
    async login () {
      this.loading = true

      const email = this.email
      const password = this.password

      this.$store
        .dispatch('login', { email, password })
        .then(() => {
          this.$store.dispatch('authConfig')
        })
        .then(() => this.loginRedirect())
        .catch(e => {
          this.authError = _.get(
            e,
            'response.data.message',
            'Error del servidor'
          )
          this.setErrorsFromServer(e, 'loginForm')
        })
        .finally(() => {
          this.loading = false
        })
    },
    focusElement (element) {
      this.$nextTick(() => {
        this.$refs[element].focus()
      })
    },
    changeLang (lang, flag) {
      localStorage.setItem('locale', lang)
      window.location.reload()
      this.flag_lang = flag
    },
    loginRedirect () {
      try {
        // eslint-disable-next-line no-undef
        nativeFunctions.login()
        // eslint-disable-next-line no-undef
        nativeFunctions.onesignalSetExternalUserId(this.userLogged.id)
      } catch (e) {
        console.log(e)
      }
      this.$router.push({ name: 'Dashboard' })
    }
  }
}
</script>

<style scoped>
 .custom-font {
  font-family: 'Futura New', sans-serif !important;
}
</style>
